import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { ProductCard } from "../ProductCard/ProductCard";
import { Link } from "react-router-dom";
import folder_content from "../../img/folder_content.png";
import { Button } from "../Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clearOneFolder } from "../../actions/folders-actions/actions";
import { deselectSelection } from "../../actions/myselection-actions/actions";
import { faFolderPlus, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import "./Selection.scss";
import ExampleProductCard from "../ProductCard/ExampleProductCard";
import { ProductCard } from "../../pages/SearchResult";
export interface ISelectionProps {
  width: any;
}

export default function Selection({ width }: ISelectionProps) {
  const selection = useSelector((state: any) => state.selection);
  const dispatch = useDispatch();
  return (
    <div className="selection_container">
      {/* <div className="list_products_header"> */}
      {width <= 575 && (
        <FontAwesomeIcon
          icon={faArrowLeft}
          onClick={() => {
            dispatch(clearOneFolder());
            dispatch(deselectSelection());
          }}
        />
      )}
      {selection &&
      selection.selectionProducts &&
      selection.selectionProducts.length > 0 ? (
        <div>
          <h6>Products</h6>
          <div className="list_products">
            {selection.selectionProducts.map((el: any, i: number) => (
              <Link
                // className="product_card col-md-auto col-12"
                className="mx-1 my-3"
                style={{ textDecoration: "none" }}
                to={`/product/MySelection/${el.id}`}
              >
                <ProductCard
                  productPage={true}
                  key={el.id}
                  index={i}
                  product={el}
                  item={{
                    main: el.images[0] ? el.images[0].path : "",
                    onHover: el.images[1] ? el.images[1].path : "",
                  }}
                />
                {/* <ExampleProductCard
                index={i}
                key={el.id}
                productPage={true}
                product={el}
                item={{
                  main: el.images[0] ? el.images[0].path : "",
                  onHover: el.images[1] ? el.images[1].path : "",
                }}
              /> */}
                {/* <ProductCard
                  index={i}
                  item={{
                    main: el.images[0] ? el.images[0].path : "",
                    onHover: el.images[1] ? el.images[1].path : "",
                  }}
                  product={el}
                  key={i}
                  productPage={true}
                /> */}
              </Link>
            ))}
          </div>
        </div>
      ) : (
        selection.selectionProducts &&
        selection.selectionProducts.length === 0 && (
          <div className="empty_collection ">
            <img src={folder_content} alt="foders image" className="mb-5" />
            <h2 className="collection_welcome mb-3">My Selection</h2>
            <p className="paragraphe collection_welcome_description mb-5 mt-4">
              Fill your Selection with your favorite products.
            </p>
            {/* {!folders.folders && (
              <Button
                innerButton="Add New Folder"
                buttonClass="submit_button_blue submit_button_blue_add_folder mt-5"
                onClick={() => {}}
                icon={<FontAwesomeIcon icon={faFolderPlus} />}
              />
            )} */}
          </div>
        )
      )}
      {/* </div> */}
    </div>
  );
}
